// src/components/MessageBox/MessageBox.tsx (o donde lo tengas ubicado)

import React from "react";

// 1. Define la interfaz para las props de MessageBox
interface MessageBoxProps {
  variant?: string; // 'variant' es opcional y de tipo string (ej: 'info', 'danger', 'success')
  children: React.ReactNode; // 'children' es el contenido que se pasa dentro del componente
}

// 2. Crea el componente funcional tipado usando React.FC
const MessageBox: React.FC<MessageBoxProps> = (props) => {
  return (
    <div className={`alert alert-${props.variant || "info"}`}>
      {props.children}
    </div>
  );
};

export default MessageBox;
